/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Img from 'modules/common/components/Img';

function Requirements({ data }) {
  
  const tabList = data || []
  
  const [requirementTab, setRequirementTab] = useState(0);

  const handleChangeRequirementTab = location => () => {
    setRequirementTab(location);
  };

  return (
    <div className="m-3">
      <div className="row mb-3">
        {/* TABS */}
        <div className="col-4">
          <div className="">
            {!_.isEmpty(tabList) ? (
              tabList.map((item, i) => (
                <div
                  key={item.id}
                  role="presentation"
                  // className="arrow-cell p-3 btn-blank"
                  className={`arrow-cell px-3 btn-blank rounded ${requirementTab === i ? 'active text-white cms-outline-primary cms-bg-color-primary' : ''}`}
                  style={{ clipPath: 'polygon(0% 0%, 95% 0px, 100% 50%, 95% 100%, 0% 100%)', marginRight: '-13px' }}
                  onClick={handleChangeRequirementTab(i)}
                >
                  {/* <div className="font-weight-bold"> */}
                  <div className="w-100 font-weight-bold py-3 d-flex justify-content-between align-items-center">
                    {_.get(item, 'attributes.name')}
                  </div>
                  {/* {i === requirementTab ? <div className="arrow" /> : ''} */}
                </div>
              ))
            ) : '' }
          </div>
        </div>
        {/* IMAGE HOLDER */}
        <div className="col-8">
          <div className="form-wrapper arrow-card p-2 rounded cms-outline-primary border-0">
            {!_.isEmpty(tabList) // CHECK TABLIST IF EMPTY
              ? (
                <React.Fragment>
                  {tabList.map((item, i) => ( // MAP AND CHECK IF ITEM IS EQUAL TO ACTIVE TAB
                    i === requirementTab ? (
                      <Img
                        key={item.id}
                        src={_.get(item, 'attributes.url')}
                        className="shadow-lg"
                        role="presentation"
                        defaultSrc={defaultPhoto}
                        width="80%"
                        alt=""
                      />
                    ) : ''
                  ))}
                </React.Fragment>
              ) : ''
            }
          </div>
        </div>
      </div>
    </div>
  );
}

Requirements.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps
  ),
]);


export default enhance(Requirements);
